import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity } from "react-native";
import { RadioButton } from "react-native-paper";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import api from "../../services/api";
import styles from "./styles";
import toast from "../../utils/toast";

const InvestorProfile = ({ navigation }) => {
  const [step, setStep] = useState(1);
  const [valueStep, setValueStep] = useState("");
  const [conservador, setConservador] = useState(0);
  const [moderado, setModerado] = useState(0);
  const [agressivo, setAgressivo] = useState(0);
  const [finalizado, setFinalizado] = useState(false);
  const [perfilAtual, setperfilAtual] = useState("");

  const intl = useIntl();

  function prevStep() {
    if (step === 1) {
      navigation.navigate("MyAccount");
      return false;
    }

    setStep(step - 1);
  }

  useEffect(() => {
    getDataUsers();
  }, []);

  const getDataUsers = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    api
      .get(`/clients/getDetails/client`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        setFinalizado(res.data.user[0].client.is_investor_profile);
        setperfilAtual(res.data.user[0].client.investor_profile);
      })
      .catch((error) => {});
  };

  function nextStep() {
    if (valueStep)
      perfil().then(() => {
        setValueStep("");
        setStep(step + 1);
      });
    else
      toast(
        intl.formatMessage({ id: "investorProfile.selecioneAlgumaOpcao" }),
        "#DA1414"
      );
  }

  async function handleSubmit() {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    let modelPerfis = [conservador, moderado, agressivo];
    let typePerfis = ["Conservador", "Moderado", "Agressivo"];
    var cont = 0;
    var data, perfil;

    let maior = Math.max(conservador, moderado, agressivo);

    modelPerfis.map((e, index) => {
      if (e == maior) {
        setperfilAtual(typePerfis[index]);
        perfil = typePerfis[index];
        cont++;
      }
    });

    if (cont == 3) {
      setperfilAtual("Moderado");
      perfil = "Moderado";
    }

    data = {
      perfil: perfil,
    };

    api
      .post("/clients/investor/profile", data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setFinalizado(true);
      })
      .catch(() => {
        toast(
          intl.formatMessage({ id: "investorProfile.erroGeral" }),
          "#DA1414"
        );
      });

    //setFinalizado(true);
  }

  async function perfil() {
    switch (valueStep) {
      case "1":
        if (step === 1 || step === 2 || step === 7 || step === 9)
          setConservador(conservador + 1);

        if (step === 3 || step === 5 || step === 8) setAgressivo(agressivo + 3);

        if (step === 4 || step === 6) setModerado(moderado + 2);

        break;
      case "2":
        if (step === 2 || step === 7 || step === 8 || step === 9)
          setModerado(moderado + 2);

        if (step === 1 || step === 4) setAgressivo(agressivo + 3);

        if (step === 3 || step === 5 || step === 6)
          setConservador(conservador + 1);

        break;
      case "3":
        if (step === 2 || step === 6 || step === 7 || step === 9)
          setAgressivo(agressivo + 3);

        if (step === 8 || step === 4) setConservador(conservador + 1);

        if (step === 1 || step === 3 || step === 5) setModerado(moderado + 2);

        break;
    }
  }

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="investorProfile.headerPerfilInvestidor" />}
      />

      {!finalizado ? (
        <>
          <View style={styles.container}>
            {step === 1 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtConheceCriptoativo" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.btnSimMasNaoInveste" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.btnSim&Investe" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.btnNaoMasQuerInvestir" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 2 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtInvestirCriptoLastro" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.btnSimCriptoMaiorSeguranca" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.btnTalvezDependeLastro" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.btnNaoPrefereRentabilidadeMaior" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 3 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtInvesteCriptPoucoConhecido" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvesteCriptPoucoConhecidoSim" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvesteCriptPoucoConhecidoNao" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvesteCriptPoucoConhecidoTalvez" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 4 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtInvestiriaCriptoBlockchain" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvestiriaCriptoBlockchainSim" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvestiriaCriptoBlockchainNao" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvestiriaCriptoBlockchainNaoConheco" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 5 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtAceitaReceberEmCriptos" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAceitaReceberEmCriptosSim" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAceitaReceberEmCriptosNao" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAceitaReceberEmCriptosTalvez" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 6 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtSelecioneFraseEscolheInvestimento" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtBuscoInfoAgenes&Midias" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvistoSeConhecoBem" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtInvestidoEmTendencias" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 7 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtOquePriorizainvestir" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtSegurancaTranquilidade" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtRentabilidadeEsg" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtRentabilidade" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 8 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtDefineExpInvestimentos" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtPossuoConhecimentoExpCripto" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtPossuoAlgumConhecimentoRendaVariavelDerivados" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtPossuoExpRendaFixa" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 9 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtQualAtitudePrecipitacoesEconomiaMercado" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtVenderiaImediatamente" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtEtendoRiscosAguardoParaVender" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtProcuroAnteciparQuedas" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 10 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtPretensoesInvestimentos" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAte50mil" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtDe51milA500mil" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtDe501milA1milhao" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="4" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtDe1.1.milhaoA3milhoes" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="5" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtMaisDe3milhoes" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}

            {step === 11 && (
              <>
                <Text style={styles.titleStep}>
                  <FormattedMessage id="investorProfile.txtQuantoPretendeInvestir12Meses" />
                </Text>
                <RadioButton.Group
                  onValueChange={(newValue) => setValueStep(newValue)}
                  value={valueStep}
                >
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="1" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtMenosDe5mil" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="2" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAte10mil" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="3" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAte100mil" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="4" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAte500mil" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="5" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAte1milhao" />
                    </Text>
                  </View>
                  <View style={styles.contentRadioButton}>
                    <RadioButton value="6" />
                    <Text style={styles.description}>
                      <FormattedMessage id="investorProfile.txtAcimaDe1milhao" />
                    </Text>
                  </View>
                </RadioButton.Group>
              </>
            )}
            <View style={styles.contentBtns}>
              <TouchableOpacity style={styles.btn} onPress={prevStep}>
                <Text style={styles.textBtn}>
                  <FormattedMessage id="investorProfile.txtVoltar" />
                </Text>
              </TouchableOpacity>
              {step === 11 ? (
                <TouchableOpacity style={styles.btn} onPress={handleSubmit}>
                  <Text style={styles.textBtn}>
                    <FormattedMessage id="investorProfile.txtFinalizar" />
                  </Text>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity style={styles.btn} onPress={nextStep}>
                  <Text style={styles.textBtn}>
                    <FormattedMessage id="investorProfile.txtAvancar" />
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </>
      ) : (
        <>
          <View style={styles.containerPerfil}>
            <Text style={styles.descriptionPerfil}>
              <FormattedMessage id="investorProfile.txtPerfilAnalisado" />
            </Text>
            <Text style={styles.perfil}>
              {perfilAtual ? <FormattedMessage id={perfilAtual} /> : <></>}
            </Text>
          </View>

          <View style={styles.contentBtns}>
            <TouchableOpacity
              style={styles.btn}
              onPress={() => {
                setStep(1);
                setFinalizado(false);
              }}
            >
              <Text style={styles.textBtn}>
                <FormattedMessage id="investorProfile.txtRefazer" />
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.btn}
              onPress={() => navigation.navigate("Tabs")}
            >
              <Text style={styles.textBtn}>
                <FormattedMessage id="investorProfile.txtSair" />
              </Text>
            </TouchableOpacity>
          </View>
        </>
      )}
    </>
  );
};

export default InvestorProfile;
